import { useMemo } from 'react';
import { useObjectTypes } from './useObjectTypes';
import { useObjectTypeId } from './useObjectTypeId';
export const useObjectTypeDefinition = objectTypeId => {
  const contextObjectTypeId = useObjectTypeId();
  const objectTypeIdToUse = objectTypeId !== null && objectTypeId !== void 0 ? objectTypeId : contextObjectTypeId;
  const data = useObjectTypes();
  return useMemo(() => {
    if (data) {
      const found = data.find(item => item.objectTypeId === objectTypeIdToUse);
      if (found) {
        return found;
      }
    }
    return null;
  }, [data, objectTypeIdToUse]);
};